module.exports = __webpack_public_path__ + "img/languages.e63279f2.png";